export default "__VITE_ASSET__BOXRrPdY__"